module.exports = "/assets/data/36da14e73d44ea2f28c3048fe42649b7-KA9.data.json";